import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "favourite-panel favourite-panel--empty" }
const _hoisted_2 = { class: "favourite-panel__filters" }
const _hoisted_3 = { class: "favourite-panel__body" }
const _hoisted_4 = { class: "favourite-panel__body-item-text" }
const _hoisted_5 = { class: "favourite-panel__body-item-text-type" }
const _hoisted_6 = { class: "favourite-panel__body-item-text-description" }
const _hoisted_7 = {
  key: 1,
  class: "favourite-panel__empty"
}

import {
	computed,
	onMounted,
	ref
} from "vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import {Favourite, favouritesStore} from "@/store/favourites";
import {orderBy} from "lodash";
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatFavouritePanel',
  setup(__props) {

const route = useRoute()
const store = favouritesStore()
const favourites = computed(() => store.favouritesList)
const sortType = ref<'asc' | 'desc' | null>(null)
const showClients = ref(true)
const showProjects = ref(true)
const searchText = ref("");

const filteredFavourites = computed(() => {
	if (!favourites.value) return null

	let modifiedFavourites = favourites.value.filter(favourite =>
		favourite.Title.toLowerCase().includes(searchText.value.toLowerCase())
	)

	if (!showClients.value) {
		modifiedFavourites = modifiedFavourites.filter(favourite => favourite.Type !== 0)
	}

	if (!showProjects.value) {
		modifiedFavourites = modifiedFavourites.filter(favourite => favourite.Type !== 1)
	}

	return sortType.value
		? orderBy(modifiedFavourites, ['Type', 'Title'], [sortType.value, sortType.value])
		: modifiedFavourites
})

const changeFavouriteSort = () => {
	switch (sortType.value) {
		case 'asc':
			sortType.value = 'desc'
			return;
		case 'desc':
			sortType.value = null
			return;
		default:
			sortType.value = 'asc'
			return;
	}
}

const getFavouriteDescription = (favourite: Favourite) => {
	return favourite.Type === 0
		? mapParams(favourite.Client!.Parameters)
		: mapParams(favourite.Project!.Parameters)
}

const mapParams = (param: object[]) => {
	return param
		.map(p => p.Instance ? `${p.Instance.Key}: ${p.Instance.Value}` : mapParams(p.ListTitle))
		.flat(2)
		.join(', ')
}

const deleteFromFavourites = async (favourite: Favourite) => {
	if (favourite.Type === 0) {
		await store.removeFavourites(favourite.Client!.Id, favourite.Type)
	} else {
		await store.removeFavourites(favourite.Project!.Id, favourite.Type)
	}
}

onMounted(() => {
	store.fetchFavourites(searchText.value)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (favourites.value && favourites.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppInput, {
              modelValue: searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              class: "favourite-panel__filters-input",
              placeholder: _ctx.$t('search_favourite'),
              "show-search-button": ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("div", {
              class: _normalizeClass({
						'favourite-panel__filters-toggle': true,
						'favourite-panel__filters-toggle--selected': showProjects.value,
					}),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showProjects.value = !showProjects.value), ["stop"]))
            }, " проекты ", 2),
            _createElementVNode("div", {
              class: _normalizeClass({
						'favourite-panel__filters-toggle': true,
						'favourite-panel__filters-toggle--selected': showClients.value,
					}),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showClients.value = !showClients.value), ["stop"]))
            }, " клиенты ", 2),
            _createVNode(AppTooltip, {
              position: "top",
              text: "Отсортировать"
            }, {
              activator: _withCtx(() => [
                (!sortType.value)
                  ? (_openBlock(), _createBlock(AppIcon, {
                      key: 0,
                      class: "favourite-panel__filters-sort",
                      name: "sort-auto",
                      width: "18px",
                      color: "#979797",
                      "hover-color": "#499259",
                      cursor: "pointer",
                      onClick: _withModifiers(changeFavouriteSort, ["stop"])
                    }))
                  : (sortType.value === 'asc')
                    ? (_openBlock(), _createBlock(AppIcon, {
                        key: 1,
                        class: "favourite-panel__filters-sort",
                        name: "arrow-down",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: _withModifiers(changeFavouriteSort, ["stop"])
                      }))
                    : (_openBlock(), _createBlock(AppIcon, {
                        key: 2,
                        class: "favourite-panel__filters-sort",
                        name: "arrow-up",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: _withModifiers(changeFavouriteSort, ["stop"])
                      }))
              ]),
              _: 1
            })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "favourite-panel__divider" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFavourites.value, (favourite) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "favourite-panel__body-item",
                key: favourite.Client?.Id || favourite.Project?.Id
              }, [
                _createVNode(AppTooltip, {
                  class: "favourite-panel__body-item-icon",
                  text: "Удалить из избранного"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "favourite",
                      width: "18px",
                      color: "#D05A4F",
                      "hover-color": "#979797",
                      cursor: "pointer",
                      onClick: ($event: any) => (deleteFromFavourites(favourite))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(favourite.Type === 0 ? 'Клиент' : 'Проект'), 1),
                  _createVNode(_component_router_link, {
                    to: {
								query: {
									page: favourite.Type === 0 ? 'client' : 'project',
									id: favourite.Type === 0 ? favourite.Client?.Id : favourite.Project?.Id,
								}
							},
                    class: "favourite-panel__body-item-text-name"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(favourite.Type === 0 ? favourite.Client?.Name : favourite.Project?.Name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(getFavouriteDescription(favourite)), 1)
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, " Вы не добавили ничего в избранное "))
  ]))
}
}

})